<template>
  <div class="eventList">
    <h3 class="center title">“中国设计年度十大事件”公众投票</h3>
    <p class="center text">每人有十次投票的权利，选出您心目中的“中国设计年度十大事件”</p>
    <div class="container">
      <div v-if="loading" class="note">
        <Icon class="turn" size="50" type="ios-loading" />
        <p>加载中...</p>
      </div>
      <template v-else>
        <template v-if="info.id">
          <div class="info">
            <div><div class="label">事件名称：</div><div class="value">{{info.eventName}}</div></div>
            <div><div class="label">推荐人/单位：</div><div class="value">{{info.recommender}}</div></div>
            <div><div class="label">申报单位：</div><div class="value">{{info.applicant}}</div></div>
            <div><div class="label">门类：</div><div class="value">{{info.type}} {{info.otherType}}</div></div>
            <div><div class="label">负责人：</div><div class="value">{{info.chargePerson}}</div></div>
            <!-- <p>联系电话： {{info.phone}}</p>
            <p>通讯地址： {{info.address}}</p> -->
            <div><div class="label">主要事迹：</div><div class="value">{{info.mainEvent}}</div></div>
            <div><div class="label">推荐理由：</div><div class="value">{{info.reason}}</div></div>
            <div class="btnWrap">
              <Button class="defaultBtn" @click="vote">{{isVote?'已投票':'投票'}}</Button>
            </div>
          </div>
          <div class="info">
            <div class="commentItem">
              <Input type="textarea" :autosize="{minRows: 4}" :maxlength="200" v-model="commentText" placeholder="请输入您的想法，200字以内"></Input>
              <div class="commentBtnWrap">
                <Button class="defaultBtn" @click="submit">评论</Button>                
              </div>
            </div>
            <div v-for="c in commentList" :key="c.id" class="commentItem">
              <p>
                <span class="bold">{{changePhone(c.userName)}}</span>：{{c.content}}
              </p>
              <p>{{toLongDateFormat(c.createdDate)}}<span v-if="gIsLogin()&&c.userId==userInfo.id" class="btnDel" @click="delComment(c.id)">删除</span></p>
            </div>
          </div>
        </template>
        <div v-else class="center">
          暂无信息详情
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import competitionService from "@/api/competition";
export default {
  data() {
    return {
      userInfo: this.$store.getters.userInfo || {},
      loading: false,
      info: {},
      isVote: false,
      voteNum: 0,
      id: null,

      commentText: "",
      commentList: []
    };
  },
  mounted() {
    this.id = this.$route.params.id;
    this.getInfo();
    if(this.gIsLogin()){
      this.getVotes();
    }
    this.getComments();
  },
  methods: {
    // 替换手机号中间4位
    changePhone(v) {
      return v.substr(0, 3) + "****" + v.substr(7, v.split("").length);
    },
    // 获取事件信息
    getInfo() {
      this.loading = true;
      competitionService.getOneTopEvent(this.id).then(res => {
        this.loading = false;
        if (res.errorNo == 0) {
          this.info = res.data;
        } else {
          this.$Message.error(res.errorMessage);
        }
      })
      .catch(() => {
        // this.$Message.error(err.message)
        this.loading = false;
        this.$Message.error("连接服务器失败，请稍后再试");
      });
    },
    // 投票
    vote() {
      if (this.gIsLogin()) {
        if (this.isVote) {
          this.$Message.info("您已为事件投票，不能重复参与。");
          return;
        }
        // 再加一步判断是否已经为10个事件透过票，如果已经达到10个事件提示并返回
        if (this.voteNum >= 10) {
          this.$Message.info("您的投票次数已用完，不能继续投票了。");
          return;
        }
        let condition = {};
        condition.eventId = this.id;
        // 发送投票请求
        competitionService.saveTopEventVote(condition).then(res => {
          if (res.errorNo == 0) {
            this.$Message.info('投票成功！')
            this.isVote = true;
          } else {
            this.$Message.error(res.errorMessage);
          }
        })
        .catch(() => {
          // this.$Message.error(err.message)
          this.$Message.error("连接服务器失败，请稍后再试");
        });
      } else {
        this.$Modal.info({
          title: "提示",
          content: "登录后才能参与投票",
          okText: "去登录",
          onOk: () => {
            this.$router.push(
              `/login?fromUrl=/top_events/detail/${this.info.id}`
            );
          }
        });
      }
    },
    // 提交评论
    submit() {
      if (this.gIsLogin()) {
        if (this.commentText == "") {
          this.$Message.info("请输入要发表的内容。");
          return;
        }
        let condition = {};
        condition.eventId = this.id;
        condition.content = this.commentText;
        // 发送评论请求
        competitionService.saveTopEventComment(condition).then(res => {
          if (res.errorNo == 0) {
            this.$Message.info('评论提交成功')
            this.commentText = "";
            this.getComments();
          } else {
            this.$Message.error(res.errorMessage);
          }
        })
        .catch(() => {
          // this.$Message.error(err.message)
          this.$Message.error("连接服务器失败，请稍后再试");
        });
      } else {
        this.$Modal.info({
          title: "提示",
          content: "登录后才能参与评论",
          okText: "去登录",
          onOk: () => {
            this.$router.push(
              `/login?fromUrl=/top_events/detail/${this.info.id}`
            );
          }
        });
      }
    },
    // 删除评论
    delComment(id){
      this.$Modal.confirm({
        title: "删除评论",
        content: "确定要删除此条评论吗？",
        onOk: () => {
          competitionService
            .deleteOneTopEventComment(id)
            .then(res => {
              if (res.errorNo == 0) {
                this.$Message.info("删除评论成功");
                this.getComments();
              } else {
                this.$Message.error(res.errorMessage);
              }
            })
            .catch(() => {
              // this.$Message.error(err.message)
              this.$Message.error("连接服务器失败，请稍后再试");
            });
        },
        onCancel: () => {
          // this.$Message.info('Clicked cancel');
        }
      });
    },
    getComments(){
      let condition = {"eventId.eq": this.id, "sort":"createdDate,DESC"};
      competitionService.getTopEventComment(condition).then(res => {
        if (res.errorNo == 0) {
          this.commentList = res.data;
        } else {
          this.$Message.error(res.errorMessage);
        }
      })
      .catch(() => {
        // this.$Message.error(err.message)
        this.$Message.error("连接服务器失败，请稍后再试");
      });
    },
    getVotes(){
      let condition = {"eventId.eq": this.id, "userId.eq": this.userInfo.id};
      competitionService.getTopEventVote(condition).then(res => {
        if (res.errorNo == 0) {
          if(res.data && res.data.length > 0){
            this.isVote = true;
          }
        } else {
          this.$Message.error(res.errorMessage);
        }
      })
      .catch(() => {
        // this.$Message.error(err.message)
        this.$Message.error("连接服务器失败，请稍后再试");
      });

      let conditionAll = {"userId.eq": this.userInfo.id};
      competitionService.getTopEventVote(conditionAll).then(res => {
        if (res.errorNo == 0) {
          if(res.data && res.data.length > 0){
            this.voteNum = res.data.length
          }
        } else {
          this.$Message.error(res.errorMessage);
        }
      })
      .catch(() => {
        // this.$Message.error(err.message)
        this.$Message.error("连接服务器失败，请稍后再试");
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.eventList {
  .title {
    padding: 15px 15px 5px;
  }
  .text {
    padding: 0 15px 35px;
  }

  .note {
    padding: 10px 0;
    text-align: center;

    .turn {
      animation: turn 1s linear infinite;
      margin-bottom: 10px;
    }
    @keyframes turn {
      0% {
        -webkit-transform: rotate(0deg);
      }
      25% {
        -webkit-transform: rotate(90deg);
      }
      50% {
        -webkit-transform: rotate(180deg);
      }
      75% {
        -webkit-transform: rotate(270deg);
      }
      100% {
        -webkit-transform: rotate(360deg);
      }
    }
  }
  .info {
    padding: 15px;
    box-shadow: 0 0 10px 2px rgba($color: #000000, $alpha: 0.2);
    border-radius: 5px;
    margin-bottom: 20px;
    line-height: 2em;

    .label {
      float: left;
      width: 95px;
      text-align: right;
      font-weight: 600;
    }
    .value {
      margin-left: 100px;
    }
    .btnWrap {
      text-align: center;
      padding: 30px 0 10px;
    }
    .commentItem {
      border-bottom: 1px solid #eeeeee;
      padding: 10px 0;

      .commentBtnWrap {
        text-align: right;
        padding: 15px 0 10px;
      }
    }
    .commentItem:last-child {
      border-bottom: none;
    }

    .btnDel{
      cursor: pointer;
      color: #d42a1b;
      float: right;
    }
  }
}
</style>
